import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TTypedThunkDispatch } from '../../types/thunk';
import { trackingActionClickAgentsFlats, trackingActionClickDevelopersFlats } from '../../actions/analytics';
import { Link } from '@cian/ui-kit';
import { IFromDevelopersRoom } from '../../types/newbuilding';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

interface IRoomCountsProps {
  fromAgentsPropsLink?: string;
  fromDeveloperPropsLink?: string;
  fromDeveloperCountsDisplay?: string;
  fromAgentsCountsDisplay?: string;
  fromDevelopersRooms: IFromDevelopersRoom[];
  isFromAgentsAndOwnersFilter?: boolean;
}

export function RoomCounts(props: IRoomCountsProps) {
  const {
    fromDeveloperPropsLink,
    fromDeveloperCountsDisplay,
    fromAgentsCountsDisplay,
    fromAgentsPropsLink,
    fromDevelopersRooms,
    isFromAgentsAndOwnersFilter,
  } = props;

  const dispatch = useDispatch<TTypedThunkDispatch>();
  const shouldShowAgentsLink = isFromAgentsAndOwnersFilter || !fromDeveloperPropsLink;

  const trackingClickFlats = React.useCallback(() => {
    if (shouldShowAgentsLink) {
      dispatch(trackingActionClickAgentsFlats());
    } else {
      dispatch(trackingActionClickDevelopersFlats('all-variants'));
    }
  }, [dispatch, shouldShowAgentsLink]);

  if (!isFromAgentsAndOwnersFilter && (!fromDevelopersRooms || !fromDevelopersRooms.length)) {
    return null;
  }

  const link = shouldShowAgentsLink ? fromAgentsPropsLink : fromDeveloperPropsLink;

  if (!link) {
    return null;
  }

  const text = shouldShowAgentsLink
    ? `${fromAgentsCountsDisplay} от${NO_BREAK_SPACE}агентов и${NO_BREAK_SPACE}собственников`
    : fromDeveloperCountsDisplay;

  return (
    <Link fontSize="M" fontWeight="bold" onClick={trackingClickFlats} href={link} target="_blank">
      {text}
    </Link>
  );
}
